import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { LoadingScreen } from '@syntra/ui/components/loading-screen';

import { paths } from 'src/routes/paths';

import DashboardLayout from 'src/layouts/dashboard';
import { FeatureFlag } from 'src/auth/feature-flags';
import { AuthGuard, OnboardingGuard } from 'src/auth/guard';
import FeatureFlagGuard from 'src/auth/guard/feature-flag-guard';

// ----------------------------------------------------------------------

const ReportBuilderPage = lazy(() => import('../pages/ReportBuilderPage'));

export const reportRoutes = [
  {
    path: paths.dashboard.reports.index,
    element: (
      <AuthGuard>
        <OnboardingGuard>
          <FeatureFlagGuard flag={FeatureFlag.ReportBuilder}>
            <DashboardLayout>
              <Suspense fallback={<LoadingScreen />}>
                <Outlet />
              </Suspense>
            </DashboardLayout>
          </FeatureFlagGuard>
        </OnboardingGuard>
      </AuthGuard>
    ),
    children: [{ element: <ReportBuilderPage />, index: true }],
  },
];
